import { Stack } from 'shared';
import { LetterIcon } from 'App/components/LetterIcon';
import { MultiSelectItemProps } from 'App/components/MultiSelectList';
import classNames from 'classnames';
import React from 'react';
import { SentryApiClient } from '_generated/api';
import styles from './SelectablePanel.module.css';

interface SelectablePanelProps
  extends MultiSelectItemProps<SentryApiClient.PanelDTO> {}

export const SelectablePanel: React.FC<SelectablePanelProps> = ({
  item,
  selected,
  disabled,
  isLastClicked,
}) => {
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.selected]: selected,
        [styles.disabled]: disabled,
        [styles.lastClicked]: isLastClicked,
      })}
    >
      <Stack>
        <Stack alignment="middle" gap={10}>
          <LetterIcon name={item.name ?? ''} />
          <div>
            <div className={styles.displayName}>{item.name}</div>
          </div>
        </Stack>
      </Stack>
    </div>
  );
};
